var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('GGGroup', {
    attrs: {
      "prop": _vm.data.template.prop,
      "order": _vm.data.factoid && _vm.data.factoid.align
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_vm.data.dataSource.data.category || _vm.data.dataSource.data.productModel ? _c('GGPhoneGrid', {
          attrs: {
            "prop": _vm.data.template.prop,
            "list": _vm.data.dataSource.data.category || _vm.data.dataSource.data.productModel
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }